import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {

  transform(value: string): any {
    if (value.length > 0) {
      return value.charAt(0).toUpperCase() + value.substr(1).toLowerCase();
    }

    return value;
  }

}
